// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-AJe","name":"Header_name__1Z0Y0","birthday":"Header_birthday__1dcfH","skeleton":"Header_skeleton__1Rzgr"};